import Person from './Person.js'
class BankContact extends Person {
  get ownerships(){
    return []
  }
  get entities(){
    return []
  }
}
export default BankContact
